import { css } from 'styled-components'

export const interFont = css`
  font-family: var(--font-inter);
`

export const soraFont = css`
  font-family: var(--font-sora);
`
